import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom"; 
import Footer from "./components/Footer";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import About from "./pages/About";
import ContactGet from "./components/ContactGet";

import { useLocation } from "react-router-dom";

import PainterServices from "./components/newservice/PainterService";
import PlumberService from "./components/newservice/PlumberService";
import CleanerServices from "./components/newservice/CleanerService";
import "../src/pages/home.css"
import Master from "./pages/Master";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  FaWhatsapp,
  FaPhone,FaShoppingCart
} from "react-icons/fa"

import AllPage from "./pages/AllPage";
import ContMost from "./components/newservice/ContMost";
import DevelopmentPage from "./components/development/DevelopmentPage";
import ErrorPage from "./pages/ErrorPage";
import HomeApplianceService from "./components/newservice/HomeApplianceService";

import AllProductShow from "./components/ecomerce/AllProductShow";
import BuyNowPage from "./components/ecomerce/BuyNowPage";
import Admin from './components/ecomerce/AdminPage'
import Category from "./components/ecomerce/Category";
import CategoryWise from "./components/ecomerce/CategoryWise";
import ProductGallery from './components/ecomerce/ProductGallery'

import RootLayout from "./components/videography/RootLayout";
import PortfolioSection from "./components/newservice/PortfolioSection";
import FoodBuyPage from "./components/ecomerce/FoodBuyPage";
import WebModal from "./components/development/WebModal";
import FloatingButtons from "./components/newservice/FloatingButtons";
function App() {

const location = useLocation();

useEffect(() => {
  let title = "OneStopService";

  switch(location.pathname) {
  case '/':
  title+=""
    break;
    case '/services':
      title += '-Service';
      break;
    case '/contact':
      title += '-Contact';
      break;
    case '/about':
      title += '-About';
      break;
    case '/contactlist':
      title += '-Contactlist';
      break;
    case '/painterservice':
      title += '-Painter Services';
      break;
    case '/plumberservice':
      title += '-PlumberServices';
      break;
    case '/cleanerservice':
      title += '-Cleaner Services';
      break;
    case '/servi':
      title += '-ContMost';
      break;
    case '/development':
      title += '-DevelopmentPage';
      break;
    case '/homeapplience':
      title += '-HomeApplianceService';
      break;
    case '/showproduct':
      title += '-All Products';
      break;
    case '/admin':
      title += '-Admin Panel';
      break;
    case '/category':
      title += '-Categories';
      break;
    default:
      title += 'OneStopService';  
  }

  document.title = title;

}, [location.pathname]);

    return (
    <div className="flex flex-col min-h-screen app-container">

<Master></Master>
<WebModal />
 {/* <PhotographyPortfolio></PhotographyPortfolio> */}
      {/* <Header /> */}
      {/* <ServiceNew></ServiceNew> */}
      <Routes>
      
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<AllPage></AllPage>} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/contactlist" element={<ContactGet/> } />
        <Route path="/painterservice" element={<PainterServices></PainterServices>}></Route>
        <Route path="/plumberservice" element={<PlumberService></PlumberService>}></Route>
        <Route path="/cleanerservice" element={<CleanerServices></CleanerServices>}></Route>
        <Route path="/servi" element={<ContMost></ContMost>}></Route>
        <Route path="/development" element={<DevelopmentPage></DevelopmentPage>}></Route>
      <Route path="*" element={<ErrorPage></ErrorPage>}></Route>
      <Route path="/homeapplience" element={<HomeApplianceService></HomeApplianceService>}></Route>
    
  <Route path='/showproduct' element={<AllProductShow></AllProductShow>}></Route>
  <Route path="/buy-now/:id" element={<BuyNowPage />} />
   <Route path="/admin" element={<Admin></Admin>} />
   <Route path="/categories" element={<Category />} />
      <Route path="/categories/:category" element={<CategoryWise />} />
       <Route path="/foodgallery" element={<ProductGallery />} />
       <Route path='/yaadeinfilms' element={<RootLayout></RootLayout>}></Route>
       <Route path="/portfolio" element={<PortfolioSection></PortfolioSection>}></Route>
               <Route path="/buy/:productName" element={<FoodBuyPage />}></Route>

      {/* Other routes */}
      </Routes>

      <Footer />
<FloatingButtons/>
      {/* <div className="floating-buttons">
      <a href="tel:+919199245536" className="icon-btn call-btn" aria-label="Call">
        <FaPhone />
      </a>
      <a
        href="https://wa.me/919199245536"
        className="icon-btn whatsapp-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>
      <a
        href="https://shamscart.vercel.app/"
        className="icon-btn call-btn"
        target="_blank"
        aria-label="Shop"
      >
        <FaShoppingCart />
      </a>
    </div> */}
            <ToastContainer  position="top-center"
  autoClose={4000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="colored"/>
    </div>
  );
}

export default App;

